import FlightTripModal from './FlightTripModal';

export default FlightTripModal;
